import FacilityPlacement from '@UI/Pages/Beneficiaries/BeneficiaryList/Helpers/FacilityPlacement';
import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

const resolveFacilityPlacement = (
	facilityId: number,
	organizations: readonly ComposedOrganization[],
): FacilityPlacement | null => {
	for (const organization of organizations) {
		const facility = organization.facilities.find((candidate) => candidate.id === facilityId);

		if (facility !== undefined) {
			return new FacilityPlacement({
				facilityId,
				facilityName: facility.name,
				organizationId: organization.id,
				organizationName: organization.name,
			});
		}
	}

	return null;
};

export default resolveFacilityPlacement;
